import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

import church from './modules/church'
import auth from './modules/auth'
import user from './modules/user'
import uploader from './modules/uploader'
import appdata from './modules/appdata'
import member from './modules/member'
import family from './modules/family'
import department from './modules/department'
import event from './modules/event'
import notification from './modules/notification'
import message from './modules/message'


Vue.use(Vuex)


export default new Vuex.Store({
	plugins: [createPersistedState()],
	modules: {
		church,
		auth,
		user,
		uploader,
		appdata,
		member,
		family,
		department,
		event,
		notification,
		message	
	}
  })
